import { render, staticRenderFns } from "./RequestPtStuff.vue?vue&type=template&id=4c3b92c8&"
import script from "./RequestPtStuff.vue?vue&type=script&lang=js&"
export * from "./RequestPtStuff.vue?vue&type=script&lang=js&"
import style0 from "./RequestPtStuff.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports